import {CheckIcon} from '@heroicons/react/20/solid'
import APP_CONFIG from 'constants/clientConfigs'
import {Link} from 'react-router-dom'
import {twMerge} from 'tailwind-merge'

export default function HeroPricing() {
  const {
    primaryColor,
    price,
    currencySymbol,
    siteName,
    appName,
    bgColor,
    textColor,
    focusVisibleColor,
    discountText,
    discountsText,
  } = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]

  const includedFeatures = [
    `Dedicated Brand Merchant page featuring up to 10 ${discountsText.toLowerCase()} or deals.`,
    `Ability to update & exchange these ${discountsText.toLowerCase()} as needed`,
  ]

  return (
    <div className="bg-white py-12 sm:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl sm:text-center">
          <h1 className="text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-balance sm:text-6xl">
            Increase your Sales with an Effective {discountText} Marketing
            Strategy
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
            {siteName} is a leading {discountText.toLowerCase()} and deal
            website that works with thousands of retailers to offer exclusive{' '}
            {discountsText.toLowerCase()}. Create your branded page and share
            your {discountsText.toLowerCase()} today.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-3xl font-semibold tracking-tight text-gray-900">
              How to get my store and {discountsText.toLowerCase()} listed
            </h3>
            <p className="mt-6 text-base/7 text-gray-600">
              By listing your savings to a custom Brand Page on {siteName}, you
              can reach the thousands of savvy shoppers who visit the site
              daily.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:gap-x-4">
              <h4 className={`text-sm font-semibold ${textColor}`}>
                What do I get with a branded page at {appName}?
              </h4>
              <div className="h-px w-full sm:w-auto sm:flex-1 bg-gray-100 mt-2 sm:mt-0" />
            </div>
            <ul className="mt-8 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-6">
              {includedFeatures.map(feature => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon
                    aria-hidden="true"
                    className={twMerge(`h-6 w-5 flex-none ${textColor}`)}
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
            <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
              <div className="mx-auto max-w-xs px-8">
                {/* <p className="text-base font-semibold text-gray-600">
                  Pay once, own it forever
                </p> */}
                <p className="mt-6 flex items-baseline justify-center gap-x-2">
                  <span className="text-5xl font-semibold tracking-tight text-gray-900">
                    {currencySymbol}
                    {price}
                  </span>
                  <span className="text-sm/6 font-semibold tracking-wide text-gray-600">
                    per month
                  </span>
                </p>
                <Link
                  to="/register"
                  className={twMerge(`mt-10 block w-full rounded-md ${bgColor} px-3 py-2 text-center text-sm 
                  font-semibold text-white shadow-sm hover:bg-${primaryColor}-500 
                  focus-visible:outline focus-visible:outline-2
                   focus-visible:outline-offset-2 ${focusVisibleColor}`)}>
                  Create your {discountText.toLowerCase()} Page
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
